import { render, staticRenderFns } from "./privateorderlist.vue?vue&type=template&id=4d41e479&scoped=true&"
import script from "./privateorderlist.vue?vue&type=script&lang=js&"
export * from "./privateorderlist.vue?vue&type=script&lang=js&"
import style0 from "./privateorderlist.vue?vue&type=style&index=0&id=4d41e479&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d41e479",
  null
  
)

export default component.exports